import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=f3445bea&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=js&"
export * from "./FormData.vue?vue&type=script&lang=js&"
import style0 from "./FormData.vue?vue&type=style&index=0&id=f3445bea&prod&lang=scss&"
import style1 from "./FormData.vue?vue&type=style&index=1&id=f3445bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3445bea",
  null
  
)

export default component.exports